import { useState, useMemo } from "react";

const allCities = [
  { name: "Chicago", route: "", tagline: "Cook County emergency passport services", highlights: ["Downtown Chicago coverage", "Serving O'Hare, Midway travelers"], badge: "Most Popular", status: "coming" },
  { name: "Springfield", route: "", tagline: "Sangamon County expedited passport processing", highlights: ["State capital area", "Serving Chatham, Rochester, Sherman"], badge: "Most Popular", status: "coming" },
  { name: "Aurora", route: "", tagline: "Kane and DuPage County passport services", highlights: ["Fox River Valley coverage", "Serving Naperville, Oswego"], badge: null, status: "coming" },
  { name: "Joliet", route: "", tagline: "Will County expedited passport services", highlights: ["Joliet area coverage", "Serving Plainfield, Shorewood"], badge: null, status: "coming" },
  { name: "Naperville", route: "", tagline: "DuPage County premium passport processing", highlights: ["Naperville area coverage", "Serving Aurora, Warrenville"], badge: null, status: "coming" },
  { name: "Rockford", route: "", tagline: "Winnebago County passport courier service", highlights: ["Northern Illinois hub", "Serving Loves Park, Machesney Park"], badge: null, status: "coming" },
  { name: "Elgin", route: "", tagline: "Kane County expedited passport services", highlights: ["Fox River Valley coverage", "Serving South Elgin, Bartlett"], badge: null, status: "coming" },
  { name: "Waukegan", route: "", tagline: "Lake County passport processing", highlights: ["Northern suburbs coverage", "Serving Gurnee, North Chicago"], badge: null, status: "coming" },
  { name: "Evanston", route: "", tagline: "Cook County North Shore passport services", highlights: ["North Shore coverage", "Serving Skokie, Wilmette"], badge: null, status: "coming" },
  { name: "Schaumburg", route: "", tagline: "Cook County northwest suburban passport hub", highlights: ["Schaumburg area coverage", "Serving Hoffman Estates, Palatine"], badge: null, status: "coming" },
  { name: "Arlington Heights", route: "", tagline: "Cook County northwest suburban passport services", highlights: ["Arlington Heights area", "Serving Mount Prospect, Buffalo Grove"], badge: null, status: "coming" },
  { name: "Cicero", route: "", tagline: "Cook County west suburban passport processing", highlights: ["Cicero area coverage", "Serving Berwyn, Stickney"], badge: null, status: "coming" },
  { name: "Skokie", route: "", tagline: "Cook County north suburban passport services", highlights: ["Skokie area coverage", "Serving Lincolnwood, Niles"], badge: null, status: "coming" },
  { name: "Oak Park", route: "", tagline: "Cook County west suburban expedited passports", highlights: ["Oak Park area coverage", "Serving River Forest, Forest Park"], badge: null, status: "coming" },
  { name: "Palatine", route: "", tagline: "Cook County northwest suburban passport services", highlights: ["Palatine area coverage", "Serving Rolling Meadows, Inverness"], badge: null, status: "coming" },
  { name: "Des Plaines", route: "", tagline: "Cook County northwest suburban passport processing", highlights: ["Des Plaines area coverage", "Serving Park Ridge, Rosemont"], badge: null, status: "coming" },
  { name: "Peoria", route: "", tagline: "Peoria County central Illinois passport services", highlights: ["Central Illinois hub", "Serving East Peoria, Washington"], badge: null, status: "coming" },
  { name: "Champaign", route: "", tagline: "Champaign-Urbana expedited passport services", highlights: ["University of Illinois area", "Serving Urbana, Savoy"], badge: null, status: "coming" },
  { name: "Bloomington", route: "", tagline: "McLean County passport courier service", highlights: ["Bloomington-Normal area", "Serving Normal, Hudson"], badge: null, status: "coming" },
  { name: "Decatur", route: "", tagline: "Macon County expedited passport processing", highlights: ["Decatur area coverage", "Serving Mount Zion, Forsyth"], badge: null, status: "coming" },
  { name: "Carbondale", route: "", tagline: "Jackson County southern Illinois passport services", highlights: ["Southern Illinois University area", "Serving Murphysboro, Marion"], badge: null, status: "coming" },
  { name: "Belleville", route: "", tagline: "St. Clair County metro east passport services", highlights: ["Metro East coverage", "Serving O'Fallon, Fairview Heights"], badge: null, status: "coming" },
  { name: "Alton", route: "", tagline: "Madison County Mississippi River passport processing", highlights: ["Riverfront area coverage", "Serving Godfrey, East Alton"], badge: null, status: "coming" },
  { name: "Moline", route: "", tagline: "Rock Island County Quad Cities passport services", highlights: ["Quad Cities coverage", "Serving Rock Island, East Moline"], badge: null, status: "coming" },
  { name: "Rock Island", route: "", tagline: "Rock Island County Quad Cities passport processing", highlights: ["Quad Cities coverage", "Serving Moline, Milan"], badge: null, status: "coming" },
  { name: "Elmhurst", route: "", tagline: "DuPage County west suburban passport services", highlights: ["Elmhurst area coverage", "Serving Villa Park, Lombard"], badge: null, status: "coming" },
  { name: "Wheaton", route: "", tagline: "DuPage County expedited passport processing", highlights: ["Wheaton area coverage", "Serving Glen Ellyn, Carol Stream"], badge: null, status: "coming" },
  { name: "Downers Grove", route: "", tagline: "DuPage County southwest suburban passport services", highlights: ["Downers Grove area", "Serving Lisle, Woodridge"], badge: null, status: "coming" },
  { name: "Normal", route: "", tagline: "McLean County Bloomington-Normal passport processing", highlights: ["Normal area coverage", "Serving Bloomington, Hudson"], badge: null, status: "coming" },
  { name: "Dekalb", route: "", tagline: "DeKalb County northern Illinois passport services", highlights: ["Northern Illinois University area", "Serving Sycamore, Cortland"], badge: null, status: "coming" },
  { name: "Galesburg", route: "", tagline: "Knox County western Illinois passport services", highlights: ["Galesburg area coverage", "Serving Abingdon, Knoxville"], badge: null, status: "coming" },
  { name: "Quincy", route: "", tagline: "Adams County western Illinois passport processing", highlights: ["Western Illinois coverage", "Serving Hannibal MO area"], badge: null, status: "coming" },
  { name: "Glenview", route: "", tagline: "Cook County north suburban passport services", highlights: ["Glenview area coverage", "Serving Northbrook, Northfield"], badge: null, status: "coming" },
  { name: "Highland Park", route: "", tagline: "Lake County North Shore passport processing", highlights: ["North Shore coverage", "Serving Lake Forest, Deerfield"], badge: null, status: "coming" },
  { name: "Orland Park", route: "", tagline: "Cook County southwest suburban passport services", highlights: ["Orland Park area coverage", "Serving Tinley Park, Oak Forest"], badge: null, status: "coming" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function IllinoisCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Illinois Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Illinois Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Illinois</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Illinois locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}